import type { AppSearchStandardEditPane } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {}

export default function standardsSearchRemoveSetAction(payload: Payload): PreparedAction {
  return {
    name: "STANDARDS_SEARCH_REMOVE_SET",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppSearchStandardEditPane = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "standards_search",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "removing",

    adverbial_object_type: "standard_set_pane",
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com"],
  }
  return createNarrative({
    titleForAnalytics: "Standards Search - Remove Set",
    newAnalyticsEvents: [newEvent],
  })
}
